import { createLive, type LiveState } from '@novachat/client';
import { useStore } from 'zustand';

/** Shared with the mobile app (packages/client/src/live.ts). */
const live = createLive();

/** The live store as a hook; `useLive.getState()`, `setState` and `subscribe` work as on any zustand store. */
export const useLive = Object.assign(<T,>(selector: (state: LiveState) => T): T => useStore(live.store, selector), live.store);

export const { setRealtime, sendRealtime, applyEvent } = live;
